import { ConcreteEncodable } from "./ConcreteEncodable";

import { LinkedOrderRequestImplEncoder } from "../../encoder/LinkedOrderRequestImplEncoder";

import * as CubiqTS from "../../index";
import { LinkedOrderRequest } from "../LinkedOrderRequest";
import { v4 as uuid } from "uuid";

export class LinkedOrderRequestImpl extends ConcreteEncodable implements LinkedOrderRequest {
  public static enType: string = "com.bcdfx.model.event.LinkedOrderRequestImpl";

  /*FID=1*/
  public product: CubiqTS.Product;
  /*FID=2*/
  public comment1: string;
  /*FID=3*/
  public comment2: string;
  /*FID=4*/
  public client: string;
  /*FID=5*/
  public account: string;
  /*FID=6*/
  public linkReference: string;
  /*FID=7*/
  public rootOrder: CubiqTS.OrderRequestDataImpl;
  /*FID=9*/
  public clientTrader: string;
  /*FID=10*/
  public stpHold: boolean;
  /*FID=11*/
  public scratchPadOrder: boolean;
  /*FID=12*/
  public oboClient: string;
  /*FID=13*/
  public oboAccount: string;
  /*FID=14*/
  public oboUser: string;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken;

  constructor() {
    super();
    this.encoder = LinkedOrderRequestImplEncoder.Instance;
    this.setEncodableType(LinkedOrderRequestImpl.enType);
    this.messageId = uuid();
  }

  public toString(): string {
    return (
      "LinkedOrderRequestImpl[" +
      "product=" +
      this.product +
      "comment1=" +
      this.comment1 +
      "comment2=" +
      this.comment2 +
      "client=" +
      this.client +
      "account=" +
      this.account +
      "linkReference=" +
      this.linkReference +
      "rootOrder=" +
      this.rootOrder +
      "clientTrader=" +
      this.clientTrader +
      "stpHold=" +
      this.stpHold +
      "scratchPadOrder=" +
      this.scratchPadOrder +
      "oboClient=" +
      this.oboClient +
      "oboAccount=" +
      this.oboAccount +
      "oboUser=" +
      this.oboUser +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
